export default "__VITE_ASSET__0dc09760__"